
import * as  React from "react";
import * as ReactGA from "react-ga";
import {Route, RouteComponentProps, withRouter} from "react-router";
import {Settings} from "./http/protocol";
import {connect, useDispatch} from "react-redux";
import {addPath, NavigationActionTypes} from "./navigation/NavigationActions";
import {Dispatch} from "redux";
import {useEffect} from "react";
import {usePrevious} from "./user/ui/utils";
import * as path from "path";


const RouteChanges = ( props : RouteComponentProps<{}>) => {
    const dispatch = useDispatch();
    const pathname = props.location.pathname;
    const prevPathname = usePrevious(pathname);
    const shouldSkipAdd = (pathname : string) => {
        if(!pathname) {
            return true;
        } else if(pathname.indexOf("/playnow") != -1) {
            return true;
        } else if(pathname.indexOf("resetpassword") != -1) {
            return true;
        } else if(pathname.indexOf("/playnow/recover") != -1) {
            return true;
        } else if(pathname.indexOf("verifyemail") != -1) {
            return true;
        } else {
            return false;
        }
    }
    useEffect(()=>{
        if(shouldSkipAdd(pathname)) {
            return;
        }

        if(pathname && pathname != prevPathname) {
            dispatch(addPath(pathname));
        }
    },[pathname, prevPathname])
    return false;
}
export default withRouter<any,any>(RouteChanges);